<template>
  <div 
    class="header-style2 produto-review-header" 
    :style="{
      'background': (((projetoWeb.ID_PROJETO_WEB) && (projetoWeb.IMAGEM)) ? 'url(' + 'https://backend.micrologos.com.br/paylogosAppAccess/acessarProjetoImagem/' + projetoWeb.HASH + ')' : 'url(../images/rewards/gift-3.jpg)')
    }"
    style="background-position: center center; background-repeat: no-repeat; background-size: contain !important;"
  >
    <div class="tf-container"></div>
  </div>
  <div class="mb-8" style="margin-bottom: 76px !important;">
    <div class="app-section bg_white_color giftcard-detail-section-1">
      <div class="tf-container">
        <div class="voucher-info">
          <h2 class="fw_6">{{ projetoWeb.DESCRICAO }}</h2>
          <a href="javascript:;" class="critical_color fw_6">
            {{ valorProduto ? formataValorMonetario(valorProduto) : "Selecione sua categoria" }}
          </a>
        </div>
        <div class="mt-2">
          <a href="#" class="note-voucher">
            Adquira agora mesmo
          </a>
          <p v-if="projetoWeb.DATA_FIM" class="mt-2 fw_4">
            Disponível até {{ formataData(projetoWeb.DATA_FIM) }}
          </p>
        </div>
      </div>
    </div>
    <div class="app-section mt-1 bg_white_color giftcard-detail-section-2">
      <div class="tf-container">
        <div class="voucher-desc" v-if="(projetoWeb.CATEGORIAS) && (projetoWeb.CATEGORIAS.length)">
          <div class="tf-form">
            <h4 class="fw_6" style="margin-bottom: 19px;">
              Suas Informações
            </h4>
            <InputSelect 
              label="Categoria" 
              v-model="emitente.idCategoriaEmitente" 
              :items="categorias" 
              @change="verificaValorCategoria"
            />
            <InputPais 
              label="País" 
              v-model="emitente.pais"
            />
            <InputText 
              label="Nome Completo" 
              v-model="emitente.nome" 
              :required="true"
            />
            <InputText label="CPF ou CNPJ" v-model="emitente.cpf" :required="true" />
            <p>O pagamento exige CPF ou CNPJ válido.</p>
            <InputDate 
              label="Data Nascimento" 
              v-model="emitente.dataNascimento" 
              :required="true"
            />
            <InputSelect 
              label="Orgão de Classe" 
              v-model="emitente.orgaoClasse" 
              :items="orgaosClasses"
            />
            <InputText 
              label="Instituição, Organização em que trabalha" 
              v-model="emitente.instituicaoOrganizacaoTrabalha"
            />
            <InputText 
              label="Profissão / Especialidade" 
              v-model="emitente.profissaoEspecialidade"
            />
            <InputCEP 
              label="CEP" 
              v-model="emitente.cep" 
              :required="emitente.pais == 'BR' ? true : false" 
              @busca="buscaCEP"
            />
            <InputText 
              label="Logradouro" 
              v-model="emitente.logradouro" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputNumber 
              ref="logradouroNumero"
              label="Logradouro Número" 
              v-model="emitente.logradouroNumero" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputText 
              label="Logradouro Complemento" 
              v-model="emitente.logradouroComplemento" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputText 
              label="Bairro" 
              v-model="emitente.bairro" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputText 
              label="Cidade" 
              v-model="emitente.cidade" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputEstado 
              v-if="emitente.pais == 'BR'" 
              label="Estado" 
              v-model="emitente.estado" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputText 
              v-if="emitente.pais != 'BR'"
              label="Estado (Duas letras)" 
              v-model="emitente.estado" 
              :maxlength="2" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <InputCelular 
              label="Telefone" 
              v-model="emitente.telefone"
            />
            <InputCelular 
              label="Celular" 
              v-model="emitente.celular" 
              :required="true"
            />
            <InputText 
              label="E-mail" 
              v-model="emitente.email" 
              :required="emitente.pais == 'BR' ? true : false"
            />
            <h4 class="fw_6" style="margin-top: 20px; margin-bottom: 20px;">
              Informações para Recibo (caso o recibo seja para empresa, por favor preencha os campos abaixo)
            </h4>
            <InputText 
              label="Nome Recibo" 
              v-model="emitente.nomeRecibo"
            />
            <InputCNPJ 
              label="CNPJ" 
              v-model="emitente.cnpjRecibo"
            />
          </div>
        </div> 
        <div class="voucher-desc" v-if="(projetoWeb.ID_PROJETO_WEB) && (projetoWeb.DESCRICAO_DETALHADA)">
          <h4 class="fw_6">Informações do Produto</h4>
          <div 
            class="mt-1 info-mais-produto" 
            :class="{'info-mais-produto-ativo': exibirMaisInformacoes}" 
            v-html="projetoWeb.DESCRICAO_DETALHADA" 
          >
          </div>
          <a href="javascript:;" class="btn-view-more" @click="exibirMaisInformacoes = !exibirMaisInformacoes">
            {{ exibirMaisInformacoes ? 'Ver menos' : 'Ver mais' }}
            <i :class="{'icon-down': !exibirMaisInformacoes, 'icon-up': exibirMaisInformacoes}"></i>
          </a>
        </div> 
      </div>
    </div>
    <div class="app-section mt-1 bg_white_color giftcard-detail-section-4">
      <div class="tf-container">
        <div class="mt-3 d-flex justify-content-between top">
          <div class="logo icon-box">
            <img :src="'https://backend.micrologos.com.br/auth/logomarcaCliente/' + projetoWeb.ID_EMITENTE_ML" alt="image">
          </div>
          <div class="desc">
            <p class="fw_4">
              Oferecido por
            </p>
            <h4 class="fw_6">
              {{ projetoWeb.EMITENTE_ML }}
            </h4>
          </div>
          <a href="#" class="icon-right"></a>
        </div>
        <p class="text-center fw_4 mt-3 mb-2">
          Esse produto está disponível
        </p>
      </div>
    </div>
  </div>
  <div class="bottom-navigation-bar bottom-btn-fixed">
    <div class="tf-container">
      <ButtonPadrao 
        label="Comprar" 
        @click="comprar" 
        :isLoading="isLoading"
      />
    </div>
  </div>
  <AlertBox ref="alertBox" @dismiss="dismissAlert">
  </AlertBox>
</template>

<script>
import Swal from "sweetalert2";
import { iniciarCompra, confirmarCompra, guardarCompra, acessarCheckout } from '@/services/checkout.service';
import moment from "moment";
import { mapActions } from "vuex";

import InputSelect from "@/components/inputs/InputSelect.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputNumber from "@/components/inputs/InputNumber.vue";
import InputDate from "@/components/inputs/InputDate.vue";
import InputCNPJ from "@/components/inputs/InputCNPJ.vue";
import InputCEP from "@/components/inputs/InputCEP.vue";
import InputCelular from "@/components/inputs/InputCelular.vue";
import InputEstado from "@/components/inputs/InputEstado.vue";
import InputPais from "@/components/inputs/InputPais.vue";

import ButtonPadrao from "@/components/buttons/ButtonPadrao.vue";

import AlertBox from "@/components/AlertBox.vue";

export default {
  name: "ProdutoView", 
  components: {
    InputSelect, 
    InputText, 
    InputNumber, 
    InputDate, 
    InputCNPJ, 
    InputCEP, 
    InputCelular, 
    InputEstado, 
    InputPais, 
    ButtonPadrao, 
    AlertBox
  }, 
  data() {
    return {
      isLoading: false, 
      exibirMaisInformacoes: false, 
      projetoWeb: {}, 
      categorias: [], 
      orgaosClasses: [{
        value: "CRM", 
        text: "CRM"
      }, {
        value: "CRP", 
        text: "CRP"
      }], 
      valorProduto: "", 
      emitente: {
        idCategoriaEmitente: "0",
        nome: "", 
        cpf: "", 
        documento: "", 
        dataNascimento: "", 
        orgaoClasse: "0", 
        instituicaoOrganizacaoTrabalha: "", 
        profissaoEspecialidade: "", 
        cep: "", 
        logradouro: "", 
        logradouroNumero: "", 
        logradouroComplemento: "", 
        bairro: "", 
        cidade: "", 
        estado: "", 
        pais: "BR", 
        telefone: "", 
        celular: "", 
        email: "", 
        nomeRecibo: "", 
        cnpjRecibo: ""
      }
    };
  },
  async mounted() {
    if(this.$route.params.hash) {
      try { this.projetoWeb = await this.obterProjetoWebHash(this.$route.params.hash); }
      catch (e) { await Swal.fire({ icon: 'error', title: 'Produto indisponível', text: e.message }); return; }

      if(this.projetoWeb.CATEGORIAS) {
        this.categorias = this.projetoWeb.CATEGORIAS.map(categoria => {
          return {
            value: categoria.ID_EMITENTE_CATEGORIA, 
            text: categoria.DESCRICAO
          };
        });
      }
    }
  },
  methods: {
    ...mapActions(["obterProjetoWebHash"]),
    formataData(data) {
      return moment(data, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY");
    },
    formataValorMonetario(valor) {
      if(valor) {
        return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
      } else {
        return "";
      }
    },
    async verificaValorCategoria() {
      await this.$nextTick();

      if(this.emitente.idCategoriaEmitente) {
        let categoria = this.projetoWeb.CATEGORIAS.find(categoria => categoria.ID_EMITENTE_CATEGORIA === this.emitente.idCategoriaEmitente);

        if((categoria) && (categoria.VALOR_PROJETO)) {
          this.valorProduto = categoria.VALOR_PROJETO;
        } else {
          this.valorProduto = "";
        }
      }
    },
    async buscaCEP(dados) {
      if(dados.bairro) {
        this.emitente.bairro = dados.bairro;
      }
      if(dados.complemento) {
        this.emitente.logradouroComplemento = dados.complemento;
      }
      if(dados.localidade) {
        this.emitente.cidade = dados.localidade;
      }
      if(dados.logradouro) {
        this.emitente.logradouro = dados.logradouro;
      }
      if(dados.uf) {
        this.emitente.estado = dados.uf;
      }
      this.emitente.logradouroNumero = "";

      await this.$nextTick();

      this.$refs.logradouroNumero.focus();
    },
    async comprar() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const confirmacao = await iniciarCompra({ HASH: this.$route.params.hash, EMITENTE: this.emitente });
        const resposta = await Swal.fire({
          title: 'Confirme sua compra', text: confirmacao.mensagem,
          input: 'text', inputLabel: 'Código de 6 dígitos',
          inputAttributes: { inputmode: 'numeric', maxlength: '6', autocomplete: 'one-time-code' },
          confirmButtonText: 'Continuar para pagamento', showCancelButton: true, cancelButtonText: 'Cancelar', showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: async codigo => {
            if (!/^[0-9]{6}$/.test(codigo)) { Swal.showValidationMessage('Informe os seis dígitos.'); return false; }
            try { return await confirmarCompra({ confirmacao: confirmacao.confirmacao, codigo }); }
            catch (e) { Swal.showValidationMessage(e.message); return false; }
          }
        });
        if (!resposta.isConfirmed) return;
        guardarCompra(this.$route.params.hash, resposta.value);
        await this.$router.push({ name: 'produtoCheckout', params: { hash: this.$route.params.hash } });
        if (resposta.value.cobranca) acessarCheckout(resposta.value.cobranca);
      } catch (e) { await Swal.fire({ icon: 'error', title: 'Não foi possível continuar', text: e.message }); }
      finally { this.isLoading = false; window.scrollTo({ top: 0, behavior: 'smooth' }); }
    },
    dismissAlert() {
      this.$router.push({
        name: "home"
      });
    }
  }
}
</script>

<style>

</style>